// tslint:disable-next-line:no-reference
///<reference path="../../common/webviewer/WebViewer.d.ts" />'
import 'jquery';
import 'jqueryui';
import '@pdftron/webviewer';
import WebViewer, { WebViewerOptions, WebViewerInstance, UI } from '@pdftron/webviewer'

import { IDocLink, IDocInfo, IGenericDocLink, IDocAccess } from './preview.d';
import { FixupRelPath, GetVersionInfo, fn } from '../utils';
import { IRawWindowBounds, GetRawWindowBounds } from '../infoma.environment';
import { IPreviewSettings } from '@common/interfaces';
import { getCurves } from 'crypto';

const setReadOnly = (on: { enableReadOnlyMode : () => void, disableReadOnlyMode : () => void }, isReadonly : boolean) => {
    on[isReadonly ? "enableReadOnlyMode" : "disableReadOnlyMode"]()
}
// Shared Code between Undocked and Docked Version of Preview
// Do Not Reference other /Scripts Code (kendo!) , otherwise must inlcude all (RWF.js!) in Preview Page!

declare global {
    interface Window {
        /** Anchors hosted on Slave Page, to be called from main page */
        UndockedViewProxies?: { [extid: string] : IUndockedViewProxy },

        /** Functionality Hosted on Main Page, to be called from Undocked Preview Page */
        UndockedCallbacks?: { [extid: string]: IExternalView };

        mozInnerScreenY?: number;
        mozInnerScreenX?: number;
    }
}

/** ID of the displayed Preview Frame */
export const ID_PreviewFrame = "DataGridIframePreview";

export const CustomTextSelection = 'CustomTextSelection'
export const CustomTextSelectionQuery = 'CustomTextSelectionQuery';

export function SetCustomTextSelectionState(ui: typeof UI, visible: boolean | undefined) {
    if(!ui || typeof(visible) !== "boolean") {
        return;
    }

    if(visible) {
        ui.enableElements([CustomTextSelection])
    } else {
        ui.disableElements([CustomTextSelection])
    }
}
/** Caution : Keep In Sync with Sharepoint (Enum Values!) Settings [RWF2]! */
export enum PreviewType {
    /** Current default (Browser) */
    Standard = 0,
    /** Browser standard with browser Plug-Ins */
    Browser = 1,
    /** Show With PDFJS */
    HTML5 = 2,
    /** DMS:viewer */
    DMSviewer = 3,
    /** DMS:anmerken */
    DMSanmerken = 4
}

/** Actual Kinds of Possible Preview Components */
enum PreviewKind {
    None = 0,
    IFrame = 1,
    WebViewer = 2,
    WindowOpen = 3,
    PDFJS = 4
}

/** Document Lin to an RWF3 Document: can possibly be annotated */
export interface IRWF3DocLink extends IDocLink {
    ID: string;
    WorkflowInstanceID: string;
    NavUrl: string;
    IsArchived: boolean;
    AllowEdit?: boolean;
    Extension: string;
}

/** Keep in Sync with "other side" **/
export interface INavPreviewDocLink extends IDocLink {
    Base64Data: string;
    Hash: string;
    No: number;
    NavSoapUrl: string;
    _NavPreview: true;
}

/** Proxy Object living on Hosting Side, accessible on Preview Side via window.opener.UndockedCallback  */
export interface IExternalView {
    /** Allows external Preview to Notify Main Instance about close */
    OnPreviewClose(bounds: IRawWindowBounds, id?: number): void;
    /** Allows external Preview to Notify Main Instance about Window Bounds Change */
    OnWindowBoundsChanged(bounds: IRawWindowBounds): void;
    /** 'Ping' functionality */
    readonly Alive: boolean;

    readonly ExternalCaption?: string;

    trigger(eventName: string, e?: any): boolean;
}

/** Proxy Object living on Hosting Side, accessible on Preview Side via window.opener.UndockedCallback  */
export interface IExternalPreview extends IExternalView {
    /** Preview Settings for External Preview */
    readonly PreviewSettings: IPreviewSettings;

    /** we must identify the current instance in a sequence of "overlapping"  open / close operations (unfortunately, problem: no unique Identifier yet) */
    readonly CurrNo: number;
}

/** Description of Proxy Object living on "Undocked" Side */
export interface IUndockedViewProxy {
    /** Current Window Bounds */
    readonly WindowBounds: IRawWindowBounds;
    /** Ping is Alive */
    readonly Alive: boolean;

    Identifier: string;
    /** Trigger Event on Slave Side */
    trigger(name: string, obj: Object);
    /**
     * Force Slave to close
     * @param origin Identifier of the Requesting Preview (if triggered from requesting side)
     */
    Close(CurrNo?: number);
}
/** Description of Proxy Object living on "Undocked" Side (TODO : Unify Preview )*/
export interface IUndockedPreviewProxy extends IUndockedViewProxy, IDocAccess {
    SetCurrentDoc(content: IDocLink);
    SetCustomTextSelectionState(active: boolean);
}

interface IError1 {
    Message?: string;
    ErrorMessage?: string;
    ExceptionMessage?: string;
    responseText?: any;
    status?: number;
    statusText?: string;
}

/** Instance of Proxy Object living on "Undocked" Side */
export class ExternalViewProxy implements IUndockedViewProxy {

    constructor(
        /** Unique Identifier for Communication */
        public Identifier: string,
        /** if true: is own window  */
        isStandalone: boolean) {
            this.Identifier = this.Identifier || fn.id()

        if (isStandalone) {
            this.InitAsStandaloneView();
        }
    }

    public trigger(name: string, obj: any) {
        const ev = this._events[name];
        if (ev) {
            ev.slice(0).forEach(item => item(obj));
        }
    }

    public bind(name: string, ev: (obj: any) => void) {
        const evs = this._events[name] || (this._events[name] = []);
        evs.push(ev);
    }

    private readonly _events: { [evName: string]: ((obj: any) => void)[] } = {};

    public get WindowBounds() {
        return GetRawWindowBounds(window);
    }

    public get Alive() {
        return !this.destroyed;
    }
    protected destroyed = false;

    closeId?: number;
    public Close(id?: number) {
        this.closeId = id;
        window.close();
    }

    /** Init as Standalone Slave View: Auto Close on Master Close, notify Master about own close */
    private InitAsStandaloneView() {
        const Identifier = this.Identifier;
        window.UndockedViewProxies = window.UndockedViewProxies || {};
        const openerWindow = window.opener as Window;
        const UndockedViewProxies = openerWindow.UndockedViewProxies = openerWindow.UndockedViewProxies || {};
        UndockedViewProxies[Identifier] = window.UndockedViewProxies[Identifier] = this;

        window.onbeforeunload = () => {
            this.destroyed = true;
            try {
                var callback = this.getCallBack();
                if (callback)
                    callback.OnPreviewClose(this.WindowBounds, this.closeId);
            } finally {
                window.opener.UndockedPreviewProxies[Identifier] = window.UndockedViewProxies[Identifier] = undefined;
            }
        };

        // Close Window if Connection to Opener Lost
        let currWBounds = this.WindowBounds;
        var strCurrWBounds = JSON.stringify(currWBounds);
        var found = false;
        var onConnected = () => {
            window.setInterval(() => {
                let callback = this.getCallBack();
                if (!callback) {
                    window.close();
                } else {
                    if (!found) {
                        found = true;
                        const caption = callback.ExternalCaption;
                        if (caption)
                            document.title = caption;
                    }
                    var newCurr = this.WindowBounds;
                    var strNewCurr = JSON.stringify(newCurr);
                    if (strNewCurr !== strCurrWBounds) {
                        strCurrWBounds = strNewCurr;
                        currWBounds = newCurr;
                        callback.OnWindowBoundsChanged(newCurr);
                    }
                }
            }, 1500);
        };

        // SetupClose Watcher once Connection available
        if (this.getCallBack()) {
            onConnected();
        } else {
            window.setTimeout(() => {
                if (!this.getCallBack())
                    close();
                onConnected();
            }, 1000);
        }
    }

    /** Get Validated Main Page Callback Functionality */
    public getCallBack() {
        try {
            var result = window.UndockedCallbacks && window.UndockedCallbacks[this.Identifier];
            if (result && result.Alive) {
                return result;
            }
        } catch (err) {
            console.log(err);
        }
        try {
            const cbx = window.opener && (<Window>window.opener).UndockedCallbacks;
            result = cbx && cbx[this.Identifier];
            if (result && result.Alive) {
                return result;
            }
        } catch (Err) { }
    }

}

export function ResolveToErrorMessage(err) {
    var err1 = <IError1>err;
    if (!err1)
        return err1;
    if ((typeof (err) === "string")) {
        try {
            return ResolveToErrorMessage(JSON.parse(err));
        } catch (xErr) {
        }
        return <string>err;
    }

    switch (err1.status) {
        case 404:
        case 401:
            return err1.statusText || `HttpError ${err1.status}`;
        default:
            if (err1.responseText)
                return ResolveToErrorMessage(err1.responseText);

            var result = err1.ExceptionMessage || err1.ErrorMessage || err1.Message;
            if (result && typeof (result) == "string")
                return result;

            return typeof (err) === "string" ? err : JSON.stringify(err);
    }
}

/** Check docLink is a RWWF3 Document Link */
export function IsRWF3(doc: IDocLink): doc is IRWF3DocLink {
    var check = <IRWF3DocLink>doc;
    return !!(check && check.WorkflowInstanceID && check.NavUrl);
}

export function IsNavPreview(doc: object): doc is INavPreviewDocLink {
    var check = <INavPreviewDocLink>doc;
    return !!check && !!check._NavPreview;
}

export function IsGenericDocLink(doc: IDocLink): doc is IGenericDocLink {
    var check = <IGenericDocLink>doc;
    return !!check && (check._GenericDocLink === true);
}

export function IsDocInfo(item: any): item is IDocInfo {
    var check = <IDocInfo>item;
    return (check && (check._IsDocError === true) || (check._IsClearDoc === true)) || false;
}

export function AsGenericDocLink(doc: IDocLink): IGenericDocLink {
    if (IsGenericDocLink(doc))
        return doc;

    if (IsRWF3(doc)) {
        return {
            Title: doc.Title,
            AllowEdit: doc.AllowEdit,
            Extension: doc.Extension,
            Url: ["RWF3", doc.WorkflowInstanceID, doc.ID || "", encodeURIComponent(doc.NavUrl), doc.IsArchived ? "true" : "false"].join("|"),
            _GenericDocLink: true
        };
    }

    if (IsNavPreview(doc)) {
        return {
            Title: doc.Title,
            Extension: doc.Extension,
            AllowEdit: false,
            Url: ["NavPreview", doc.NavSoapUrl, doc.No, doc.Hash].join('|'),
            _GenericDocLink: true,
        };
    }
}

const SupportedByBrowserExt = ["pdf", "bmp", "gif", "png", "txt", "jpg", "jpeg"];
const SupportedByGroupDocsExt = [
    "pdf", // PDF
    "doc", "docx", "docm", "dot", "dotx", "dotm", // MS Word
    "xls", "xls2003", "xlsx", "xlsm", "xlsb", "xml", // MS Excel
    "ppt", "pptx", "pps", "ppsx", // MS PowerPoint
    "vsd", "vdx", "vss", "vsx", "vst", "vtx", "vsdx", "vdw", // MS Visio
    "mpp", "mpt", // MS Project
    "msg", "eml", "emlx", // MS Outlook
    "odt", "ott", "ods", "odp", // OpenDocument
    "htm", "html", "mht", "mhtml", // HyperText Markup Language
    "dxf", "dwg", // AutoCAD
    "bmp", "gif", "jpg", "jpeg", "png", "tif", "tiff", "ico", // Images
    "txt", "rtf", "xps", "csv", "epub" // Other
];

export interface IExtOptions {
    OnInstanceReady?: (instance: WebViewerInstance) => any;
}


function isEmbedded() {
    return (window.location.search || "").indexOf('embedded=true') >= 0;
}
const adjustPath = (p: string) => {
    return isEmbedded() ? p : FixupRelPath(p)
};
const getAnnotUrl = () => adjustPath((isEmbedded() ? '../../../../' : './../../../../') + 'infoma.web/annotations')

const getCurrentDocId = () => window["_docId"];
const setCurrentDocId = (val: string | undefined) => window["_docId"] = val;
/**
* PDF Net WebViewer for Displaying RWF3 Documents to be included in "Undocked" preview also!
*/
export class RWFWebViewer  {
    /** Problem : Load Document will fail on not read instance  */
    public Ready: JQueryPromise<RWFWebViewer>;
    public readonly element: HTMLElement;
    constructor(options: WebViewerOptions, element: HTMLElement, extoptions: IExtOptions) {
        this.element = element;
        WebViewer(adjustDefaultOptions(), element).then((instance : WebViewerInstance) => {
            this.Instance = instance;
            const currDoc = this.currDoc;
            const uiInstance = instance.UI;
            const docViewer = instance.Core.documentViewer;
            uiInstance.setPrintQuality(3); // Increase default printQuality
            uiInstance.setNoteDateFormat('DD.MM.YYYY HH:MM');

            /** Call JQuery trigger (+handle we are in undocked child preview sceanrio also) */
            const trigger = (p: string, extra?: Object) => {
              try {
                $(window).trigger(p, extra);
                (window.opener as Window)?.UndockedCallbacks?.ExternalPreview?.trigger(p, extra);
                return true;
              } catch (err) {
                console.log("err[trigger]:" + err);
                return false;
              }
            }

            docViewer.addEventListener("mouseLeftUp", () => {
                const extra = { Result : undefined }
                if(trigger(CustomTextSelectionQuery, extra)) {
                  SetCustomTextSelectionState(uiInstance, extra.Result);
                }
            });

            uiInstance.textPopup.add([
                {
                    type: 'actionButton',
                    dataElement :CustomTextSelection,
                    title: 'Markierung in aktuelles Feld übernehmen',
                    img: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>',
                    onClick: () => {
                        var extra = { Result: false, Text: docViewer.getSelectedText() };
                        trigger(CustomTextSelection, extra );
                    }
                  }
            ]);

            if (extoptions && typeof extoptions.OnInstanceReady === "function") {
                extoptions.OnInstanceReady(instance);
            }

            if (uiInstance && typeof uiInstance.setLanguage === "function") {
                // WTF: with version 8.2 uiInstance.setLanguage("de")fails wOut defer ?!?!
                //but not in test app !?!?!
                window.setTimeout(() => { uiInstance.setLanguage("de"); }, 1000);
            }

            if (instance && !getCurrentDocId() && currDoc && currDoc.docId) {
                this.doLoadDocument(currDoc.docId, currDoc.allowEdit);
            }
        });

        // SetUp Promise to be resolved upon Viewer ready
        var r = $.Deferred<RWFWebViewer>();
        this.Ready = r.promise();
        var doResolve = () => {
            // timeout: wOut intercept- functionality in RwfViewerConfig get hooke too late for first doc display
            window.setTimeout(() => r.resolve(this));
            $(element).off("ready", doResolve);
            doResolve = () => { };
        };
        $(element).on("ready.navViewer", doResolve);
        function adjustDefaultOptions() {
            // remove unwanted ui actions
            (options.disabledElements || (options.disabledElements = [])).splice(0, 0,
                "signatureToolButton",
                "polylineToolButton",
                "polygonToolButton",
                "cloudToolButton",
                "calloutToolButton",
                "fileAttachmentToolButton",
                "cropToolButton",
            );

            const appVersion = GetVersionInfo();
            options.extension = 'xod';
            return <WebViewerOptions>$.extend(<WebViewerOptions>{
              path: './Preview/WebViewer/libV8123/',
                // MSQQQ dist/rwf!!!
                config: adjustPath("dist/rwf/rwfviewerconfig.bundle.js?ver=" + ("" + appVersion.Version + "_" + appVersion.PatchLevel))
            }, options);
        }
    }

    destroy() {
        this.Ready = $.Deferred<any>().reject('destroyed');
        $(document).add(this.element).off(".navViewer");
        var iframe = <HTMLIFrameElement>$("iframe", this.element)[0];
        if (iframe) {
            try {
                const ctw = iframe && iframe.contentWindow;
                if (ctw) {
                    var rc = <WebViewerInstance>ctw["readerControl"];
                    if (rc) {
                        rc.UI.closeDocument();
                    }
                    const i$ = <JQueryStatic>ctw["$"];
                    if (i$) {
                        i$(iframe.contentDocument).unbind();
                    }
                    // remove all frame children
                    while (ctw.document.body.firstChild) {
                        ctw.document.body.removeChild(ctw.document.body.firstChild);
                    }
                }
                iframe.src = 'about:blank';
                iframe.parentNode.removeChild(iframe);
            } catch (err) {
                if (window.console && window.console.log) {
                    window.console.log("RWFWebViewer.destroy(iframe):" + err);
                }
            }
        };

        try {
            // force garbarge collection for IE only
            var gc = window["CollectGarbage"];
            if (typeof gc === "function") {
                gc();
            }
        } catch (err) {
            if (window.console && window.console.log) {
                window.console.log("RWFWebViewer.destroy(CollectGarbage):" + err);
            }
        }
    }

    public Instance: WebViewerInstance;

    closeWorkflowDocument() {
        var instance = this.Instance;
        if (instance && getCurrentDocId()) {
            instance.UI.closeDocument();
            setCurrentDocId(undefined)
        }
        delete this.currDoc;
        $(this.element).trigger("closeWorkflowDocument");
    }
    doLoadDocument(docId: string, allowEdit: boolean) {
        if (!this.Instance) {
            this.currDoc = { allowEdit: allowEdit, docId: docId };
            return;
        }

        let instance = this.Instance,
        documentViewer = instance.Core.documentViewer,
        annotManager = documentViewer.getAnnotationManager(),
        element = $(this.element),
        url = getAnnotUrl() + "/document?did=" + encodeURIComponent(docId),  //URL path to the document
        isReadonly = allowEdit !== true;
        setReadOnly(annotManager, isReadonly);
        // allows rejecting of current on next load
        element.trigger("loadWorkflowDocument");



        $(document).on("RWFAnnotationsSaved.navViewer", (e, a) => {
            // TODO : Refresh Docs on Extension Changed ....
            //alert(this.getInstance().getDocumentViewer().getAnnotationManager().exportAnnotations());
        });

        setCurrentDocId(undefined);
        instance.UI.loadDocument(url, <any>{ filename: 'dok.xod', documentId: docId, streaming: true });
        setCurrentDocId(docId);
        if(isReadonly) {
          instance.UI.disableElements(['ribbons']);
        } else {
          instance.UI.enableElements(['ribbons']);
        }
        setReadOnly( this.Instance.Core.documentViewer.getAnnotationManager(), isReadonly);
        this.currDoc = { allowEdit: allowEdit, docId: docId };
    }
    private currDoc: { docId: string, allowEdit: boolean };
}

export class RWFDocViewer {
    public readonly element: JQuery;
    public readonly options: IPreviewSettings;
    constructor(element, options: IPreviewSettings) {
        this.element = $(element);
        this.options = options || (options = <any>{});

        this.FallbackContent = $("<div></div>").appendTo(this.element).height("100%");
    }

    destroy() {
        if (this._rwfWebViewer)
            this._rwfWebViewer.destroy();
    }

    public get WebViewer(): RWFWebViewer {
        if (!this._rwfWebViewer) {

            // Delayed Instantation (wout. e.g. Problems in firefox ...)
            const extOptions: IExtOptions = {
                OnInstanceReady: this.options.OnInstanceReady
            };
            const options = this.options;
            var viewer = $("<div></div>").appendTo(this.element).width("100%").height("100%");
            this._rwfWebViewer = new RWFWebViewer(<any><Partial<WebViewerOptions>>{
                extension: 'xod',
                enableReadOnlyMode: options.enableReadOnlyMode,
                annotationUser: options.annotationUser,
                disabledElements: options.disabledElements
            }, viewer[0], extOptions);
        }

        return this._rwfWebViewer;
    }
    private _rwfWebViewer: RWFWebViewer;

    public readonly FallbackContent: JQuery;
    private IFrameContent: JQuery;

    public SetDocLink(docLink: IDocLink) {
        return this.SetCurrent(this.options, docLink);
    }

    public SetCurrent(previewSettings: IPreviewSettings, docLink: IDocLink): any | PromiseLike<any> {
        var me = this,
            url = docLink && docLink.Url,
            getwebViewer = (forceCreate: boolean) => forceCreate ? this.WebViewer : this._rwfWebViewer,
            fallbackContent = this.FallbackContent,
            previewType = previewSettings.PreviewType || PreviewType.Standard,
            kind = GetPreviewKind(previewSettings, docLink);

        switch (kind) {
            case PreviewKind.WebViewer:
                return SetWebViewer(AsGenericDocLink(docLink));

            case PreviewKind.IFrame:
                SetIFrame(docLink && docLink.Url);
                return;

            case PreviewKind.PDFJS:
                var realUrl = (this.options.relativePath || "") + "/scripts/pdfjs/web/viewer_infoma.html?" + EncodeQueryData({ file: GetEncodedDocUrl(docLink && docLink.Url) });
                SetIFrame(realUrl);
                return;

            case PreviewKind.WindowOpen:
                if (url)
                    window.open(url);
                return;

            case PreviewKind.None:
            default:
                let link = docLink && docLink.Url,
                    title = docLink && docLink.Title ? ` f&uuml;r <b>${$("<div/>").text(docLink.Title)[0].innerText}</b>` : ``;
                let openExtern = link && `Sie k&ouml;nnen das Dokument aber <a href='${link}' target='_blank'>extern &ouml;ffnen</a>.` || "";
                let text = `<div style='width: calc(100% - 20px); height: calc(100% - 20px); text-align: center; padding: 10px; color: #888;'>
<i class='fa fa-meh-o' aria-hidden='true' style='font-size: 48px;margin:10px 0 15px 0;'></i><br/>
Keine Vorschau mit der aktuellen Vorschaukomponente ${PreviewType[previewType]}${title} m&ouml;glich.<br/>
${openExtern}</div>`;
                return SetNone().append($(text));
        }

        function SetNone(text?: string) {
            ResetWebViewer(true);
            ResetIFrame();
            fallbackContent.show();
            return fallbackContent.text(text || "");
        }

        function SetWebViewer(docLink?: IGenericDocLink) {
            ResetIFrame();
            const webViewer = getwebViewer(true);
            $(webViewer.element).show();
            fallbackContent.hide();

            return webViewer.Ready.then(() => {
                if (docLink && docLink.Url) {
                    // QQQ : In Rwf we can not edit non pdf docs yet (change extension)
                    const webViewerAllowEdit = !me.options.enableReadOnlyMode && docLink.AllowEdit && (!docLink.Extension || ("" + docLink.Extension).toLowerCase() == 'pdf');
                    return webViewer.doLoadDocument(docLink.Url, webViewerAllowEdit);
                } else {
                    return webViewer.closeWorkflowDocument();
                }
            });
        }

        function SetIFrame(url?: string) {
            ResetWebViewer(true);
            fallbackContent.hide();
            ResetIFrame(url);
        }

        function ResetWebViewer(hide: boolean) {
            const webViewer = getwebViewer(false);
            if (webViewer) {
                const instance = webViewer.Instance;
                if (instance) {
                    if (getCurrentDocId()) {
                        webViewer.closeWorkflowDocument();
                    }
                    if (hide) {
                        $(webViewer.element).hide();
                    }
                }
            }
        }

        function ResetIFrame(url?: string) {
            var iframeContent = me.IFrameContent;
            if (iframeContent) {
                iframeContent.remove();
            }
            delete me.IFrameContent;

            if (url) {
                var txtIframe = `<iframe id="${ID_PreviewFrame}" src="${url}" style="width: 100%; height: 100%; border: 0;" />`;
                me.IFrameContent = $(txtIframe).appendTo(me.element);
            }
        }

    }

    public SetFallbackContent(text: string, isHtml?: boolean, hide?: boolean) {
        var webViewer = this._rwfWebViewer,
            fallbackContent = this.FallbackContent;
        if (getCurrentDocId())
            webViewer.closeWorkflowDocument();

        if (isHtml)
            var html = text;
        else {
            html = $("<div style='width: calc(100% - 20px); height: calc(100% - 20px); text-align: center; padding: 10px; color: #888;' class='idms_Panel_Padding'></div>").text(text)[0].outerHTML;
        }

        fallbackContent.html(html).show();

        if (hide && webViewer?.Instance) {
            $(webViewer.element).hide();
        }
    }
}

/** Get Actual PreviewKind from Stttings/Type + concrete doc */
function GetPreviewKind(settings: IPreviewSettings | PreviewType, doc: IDocLink) {
    var pTypes = (IsPreviewSettings(settings) ? settings.PreviewType : settings) || PreviewType.Standard;

    function getDefault() {
        if (doc && doc.Extension && !IsPreviewableInBrowser(doc.Extension))
            return PreviewKind.None;
        return PreviewKind.IFrame;
    }
    switch (pTypes) {
        case PreviewType.Standard:
        case PreviewType.Browser:
            return getDefault();

        case PreviewType.HTML5:
            if (IsPDF(doc && doc.Extension))
                return PreviewKind.PDFJS;
            return getDefault();

        case PreviewType.DMSviewer:
        case PreviewType.DMSanmerken:
            if (AsGenericDocLink(doc))
                return PreviewKind.WebViewer;
            return getDefault();

        default:
            if (IsRWF3(doc)) {
                return PreviewKind.WebViewer;
            }
            if (doc && !IsViewable(settings, doc))
                return PreviewKind.WindowOpen;
    }
    return PreviewKind.None;
}

/** Extract document url from parameter (if present) and encode it. Return encoded url otherwise. */
function GetEncodedDocUrl(docUrl: string): string {
    // Remove docUrl prefix, if present
    var previewUrlParam = "?docUrl=";
    var prefixIndex = docUrl.indexOf(previewUrlParam);
    if (prefixIndex >= 0) {
        docUrl = docUrl.substr(prefixIndex + previewUrlParam.length);
    }

    var isUrlEncoded = decodeURI(docUrl) != docUrl;
    if (isUrlEncoded) {
        return docUrl;
    }
    else {
        return encodeURI(docUrl);
    }
}

/** Determine if the current doc is previewable with the current viewer */
function IsViewable(previewType: PreviewType | IPreviewSettings, extension: IDocLink | string) {
    if (!(typeof (extension) === "string")) {
        var ext = extension.Extension;
    } else {
        ext = extension;
    }

    if (!ext)
        return false;

    if (IsPreviewSettings(previewType))
        var pType = previewType.PreviewType;
    else
        pType = previewType;

    switch (pType) {
        case PreviewType.Standard:
        case PreviewType.Browser:
            return IsPreviewableInBrowser(ext);
        case PreviewType.HTML5:
            return IsPDF(ext) ||
                IsPreviewableInBrowser(ext); // Fallback: Browser viewer
        case PreviewType.DMSviewer:
        case PreviewType.DMSanmerken:
            return IsPreviewableInGroupDocs(ext);
        default:
            return false;
    }
}

/** Determine if doc is previewable by GroupDocs */
function IsPreviewableInGroupDocs(extension: string) {
    if (!(typeof extension == "string"))
        return false;

    var ext = extension.toLocaleLowerCase();
    return SupportedByGroupDocsExt.indexOf(ext) >= 0;
}

/** Determine if doc is previewable in browser */
function IsPreviewableInBrowser(extension: string) {
    if (!(typeof extension === "string"))
        return false;

    var ext = extension.toLocaleLowerCase();
    return (!ext) || (SupportedByBrowserExt.indexOf(ext) >= 0);
}

/** Determine if doc is a PDF file */
function IsPDF(extension: string) {
    var check = extension && extension.toLocaleLowerCase && extension.toLocaleLowerCase();
    return check == "pdf" || check == ".pdf";
}

/** Preview Settings TypeGuard */
function IsPreviewSettings(p: any): p is IPreviewSettings {
    var check = <IPreviewSettings>p;
    var cType = typeof (check && check.PreviewType);
    return cType === "string" || cType === "number";
}

/** Usage:
  * var data = { 'first name': 'George', 'last name': 'Jetson', 'age': 110 };
  * var querystring = EncodeQueryData(data);
  */
function EncodeQueryData(data: { [name: string]: any }) {
    var ret = [];
    for (var d in data) {
        var value = data[d];
        if (value != undefined && value != null) {
            ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(value));
        }
    }
    return ret.join("&");
}
